




import Vue from 'vue'

export default Vue.extend({
  name: 'AudioPlayer',
  props: {
    volume: {
      type: Number,
      default: 0
    },
    stream: {
      type: Object
    },
    channel: {
      type: String
    },
    split: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    volume () {
      if (this.gainGeneral !== null) { // gainGeneral not created yet
        let gain = this.volume / 100
        if (gain < 0) gain = 0
        if (gain > 1) gain = 1
        if (isNaN(gain)) gain = 0
        this.gainGeneral.gain.value = gain
      }
    }
  },
  beforeDestroy () {
    if (this.audioCtx !== null) {
      this.audioCtx.close()
    }
  },
  data: () => ({
    gainGeneral: null as null | GainNode,
    audioCtx: null as null | AudioContext,
    setupInterval: null as null | NodeJS.Timeout
  }),
  mounted () {
    if (this.stream !== undefined && this.stream !== null) {
      this.setupInterval = setInterval(() => {
        if (this.gainGeneral === null) {
          this.setupStream()
        }
      }, 1000)
    }
  },
  methods: {
    setupStream () {
      if (this.stream !== null && this.stream.hasOwnProperty('srcObject') && this.stream.srcObject !== null) {
        if (this.stream.srcObject.active && this.stream.srcObject.getAudioTracks().length > 0) {
          this.audioCtx = new AudioContext()
          const source = this.audioCtx.createMediaStreamSource(this.stream.srcObject)
          this.gainGeneral = this.audioCtx.createGain()
          this.gainGeneral.gain.value = this.volume / 100
          if (this.channel !== 'mono') {
            this.gainGeneral.gain.value = this.volume / 100
            const splitter = this.audioCtx.createChannelSplitter(2)
            const merger = this.audioCtx.createChannelMerger(2)
            source.connect(splitter)
            if (this.channel === 'left') {
              splitter.connect(merger, 0, 1)
              splitter.connect(merger, 0, 0)
            } else if (this.channel === 'right') {
              splitter.connect(merger, 1, 1)
              splitter.connect(merger, 1, 0)
            }
            merger.connect(this.gainGeneral)
          } else {
            source.connect(this.gainGeneral)
          }
          this.gainGeneral.connect(this.audioCtx.destination)
          if (this.setupInterval !== null) {
            clearInterval(this.setupInterval)
          }
        }
      }
    }
  }
})
